export default {
  businessLogisticsCompanyList: {
    table: {
      orderNumber: '序号',
      logisticsCompanyNameInput: '请输入物流商名称',
    },
    editLogisticsCompany: '编辑物流商',
    addLogisticsCompany: '新增物流商',
    Not: '未导入',
    Imported: '已导入',
    To: '待导入',
    be: '待回写',
    Uploaded: '已上传',
    number: '物流单号',
    name: '物流名称',
    status: '物流状态',
    or: '是否导入',
    batchEmail: '批量发邮件',
    batchDone: '批量完结',
    email: '发邮件',
    done: '完结',
    ps1: '只有物流业务为ALLI并且物流状态未完成的才被可以发邮件',
    ps2: '只有物流状态未完成的才可以完结该订单',
  },
};
